export default __webpack_public_path__ + "static/media/blockgraph_id.471526c1.csv";